var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-timeline-item',{staticClass:"my-3 mt-5 part-item",attrs:{"fill-dot":"","color":"grey","icon-color":"grey lighten-2","large":"","icon":_vm.icon}},[_c('v-layout',{attrs:{"justify-space-between":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_c('v-flex',{attrs:{"xs5":"","text-xs-right":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }